<template>
  <vx-card class="mt-base" :title="activityTitle">
    <p class="mb-5">
      Whether you’re a construction manager, carpenter, or surveying technician, knowing the
      quantity of materials that will be needed is an important part of working in the construction
      industry. In this activity, you’ll get some practice working out how many studs you’ll need
      for walls in your home.
    </p>
    <div class="vx-row my-5 flex justify-center">
      <div class="vx-col xl:w-2/3 lg:w-2/3 w-full my-5">
        <h4 class="mb-5">How Many Studs?</h4>
        <p class="mb-5">
          Look at the diagram of a timber-framed wall on the right. The item labelled number 5 in
          the first picture is called a stud. It’s a crucial part of the skeleton of framed walls.
          You probably have lots inside the walls of your home.
        </p>
        <p class="mb-5">
          For this activity, you’re going to calculate how many studs you’d need to frame the walls
          in your room if they were all timber-framed. Don’t worry if some of the walls in your home
          aren't - this is still good practice!
        </p>
        <p class="mb-5">
          In Australia, there are various rules for the distances required between each stud to
          ensure sturdy construction. These distances can range from 450mm to 600mm from the centre
          of one stud to the centre of the next. For the purposes of this activity, we’ll assume a
          distance of 450mm between each stud.
        </p>
        <p class="mb-5">
          Now, using the dimensions of your room as taught in activity 3, for each wall work out the
          number of studs required by dividing the length of the wall in mm by 450.
        </p>
      </div>
      <div class="vx-col xl:w-1/3 lg:w-1/3 w-full my-5">
        <img
          src="@/assets/images/experiences/construction/activity_51.png"
          class="img-responsive mx-auto mb-10"
          alt="A cut-away view of a timber-framed wall containing a window opening, with six numbered callouts pointing to the frame members. Callout 5 points to a vertical stud."
        />
        <img
          src="@/assets/images/experiences/construction/activity_52.png"
          class="img-responsive mx-auto"
          alt="A timber wall frame seen from the front. An arrow spans the full length of the wall, and a short arrow between two studs marks the stud placement, measured on centre."
        />
      </div>
    </div>

    <p class="mb-5">
      Do this for each wall in your room. You’ll also need to add in 3 studs for each 90° angle in
      the room.
    </p>

    <div class="overflow-hidden">
      <p class="float-left py-2 pr-2"><strong>Length of wall</strong></p>
      <text-block
        v-model="data['question1']"
        :editable="isEditable"
        style="width: 100px; float: left"
        pclass="my-2"
      />
    </div>

    <div class="overflow-hidden">
      <p class="float-left py-2 pr-2"><strong>Length of wall ÷ 450 =</strong></p>
      <text-block
        v-model="data['question2']"
        :editable="isEditable"
        style="width: 100px; float: left"
        pclass="my-2"
      />
    </div>
    <div class="overflow-hidden">
      <p class="float-left py-2 pr-2"><strong>Number of 90° corners </strong></p>
      <text-block
        v-model="data['question3']"
        :editable="isEditable"
        style="width: 100px; float: left"
        pclass="my-2"
      />
      <p class="float-left py-2 px-2"><strong>x3 =</strong></p>
      <text-block
        v-model="data['question4']"
        :editable="isEditable"
        style="width: 100px; float: left"
        pclass="my-2 "
      />
    </div>

    <div class="overflow-hidden">
      <p class="float-left py-2 pr-2">
        <strong>How many studs are needed for the walls in your room? </strong>
      </p>
      <text-block
        v-model="data['question5']"
        :editable="isEditable"
        style="width: 100px; float: left"
        pclass="my-2"
      />
    </div>
    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';

export default {
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/psychology/positive_refaming_trigger.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/0tqq66zwa7g',
      },
      answers: {
        question1: null,
        question2: null,
        question3: null,
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>
